import React from "react";

import AgGridTable from "components/AgGrid/AgGridContainer";

import TableWrapper from "components/AgGrid/TableWrapper";
import { Column } from "components/Layout";

import {
  BillingDocumentColId,
  BillingDocumentColumnDef,
  BusinessColId,
  BusinessColumnDef,
  FixWarningsActionColumn,
} from "constants/columnDefinitions";

import { selectActiveBillingRunWarnings } from "selectors";
import { useSelector } from "react-redux";

const getRowId = params => params.data.billingDocument?.id;

const columnDefs = [
  BillingDocumentColumnDef[BillingDocumentColId.DOCUMENT_TYPE],
  BillingDocumentColumnDef[BillingDocumentColId.DOCUMENT_NUMBER],
  BusinessColumnDef[BusinessColId.NAME],
  BillingDocumentColumnDef[BillingDocumentColId.WARNINGS],
  FixWarningsActionColumn,
];

export const Warnings = () => {
  const rowData = useSelector(selectActiveBillingRunWarnings);

  return (
    <Column fullHeight>
      <AgGridTable
        columnDefs={columnDefs}
        getRowId={getRowId}
        rowData={rowData}
        showGlobalSearchFilter={false}
        hideHeader
        WrapperComponent={TableWrapper}
      />
    </Column>
  );
};
